var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginSsoPage loginComponent"},[_c('h1',[_vm._v("Logging In")]),_c('br'),_c('br'),_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"#316094","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }